import React, { useEffect } from 'react'

export default function Toast({ message, type = 'info', duration = 2500, onClose }) {
  useEffect(() => {
    if (!message) return
    const t = setTimeout(onClose, duration)
    return () => clearTimeout(t)
  }, [message, duration, onClose])

  if (!message) return null

  const color =
    type === 'error'
      ? 'bg-red-600 text-white'
      : type === 'success'
      ? 'bg-green-600 text-white'
      : 'bg-gray-800 text-white'

  return (
    <div className={`fixed bottom-4 right-4 rounded px-3 py-2 text-sm shadow ${color}`}>
      {message}
    </div>
  )
}
